
export enum NAVIGATION_BAR_HEIGHT {
  LARGE = 137,
  MEDIUM = 63,
  EMPTY = 0,
}